import { useState } from "react";
import { Mail, MapPin, Clock } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please complete all fields"); return; }
    toast.success("Message sent — we'll be in touch shortly");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <>
      <Seo title="Contact | Just Peptides Supply" description="Get in touch with Just Peptides Supply for product, shipping, and consultation questions." path="/contact" />
      <section className="mx-auto max-w-5xl px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-2">
        <div>
          <p className="font-mono-label text-xs uppercase tracking-[0.2em] text-brand-blue">Contact</p>
          <h1 className="mt-2 font-display text-4xl text-brand-navy tracking-tight">Get in touch</h1>
          <p className="mt-4 text-brand-navy/60">Questions about products, shipping, or a consultation? Reach out and our team will respond promptly.</p>
          <div className="mt-8 space-y-5">
            <Info icon={Mail} label="Email" value="info@justpeptidessupply.com" />
            <Info icon={MapPin} label="Shipping" value="Domestic — fast U.S. shipping" />
            <Info icon={Clock} label="Response time" value="Within 1 business day" />
          </div>
        </div>

        <form onSubmit={submit} className="rounded-2xl border border-brand-navy/10 bg-white p-7" data-testid="contact-form">
          <div className="space-y-4">
            <div><Label>Name</Label><Input value={form.name} onChange={set("name")} className="mt-1.5" data-testid="contact-name" /></div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={set("email")} className="mt-1.5" data-testid="contact-email" /></div>
            <div><Label>Message</Label><Textarea value={form.message} onChange={set("message")} rows={5} className="mt-1.5" data-testid="contact-message" /></div>
            <Button type="submit" className="w-full rounded-full bg-brand-navy hover:bg-brand-blue text-white h-12" data-testid="contact-submit">Send Message</Button>
          </div>
        </form>
      </section>
    </>
  );
}

const Info = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3">
    <div className="rounded-lg bg-brand-mist p-2.5"><Icon className="h-5 w-5 text-brand-blue" /></div>
    <div>
      <p className="font-mono-label text-[11px] uppercase tracking-[0.15em] text-brand-navy/45">{label}</p>
      <p className="text-brand-navy font-medium">{value}</p>
    </div>
  </div>
);
